import ErrorsType from '../typings/ErrorsType';

class ApiError {
  name = 'ApiError';

  errors: { [key: string]: Array<string> } | undefined;

  statusCode: number;

  constructor(body: ErrorsType) {
    this.errors = body.errors;
    this.statusCode = body.statusCode;
  }
}

export default ApiError;
